import { render, staticRenderFns } from "./mail-confirm-reminder.vue?vue&type=template&id=03fb6d94"
import script from "./mail-confirm-reminder.vue?vue&type=script&lang=js"
export * from "./mail-confirm-reminder.vue?vue&type=script&lang=js"
import style0 from "./mail-confirm-reminder.vue?vue&type=style&index=0&id=03fb6d94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports